import { render, staticRenderFns } from "./MaintenanceViewComments.vue?vue&type=template&id=c6d43a0a"
import script from "./MaintenanceViewComments.vue?vue&type=script&lang=js"
export * from "./MaintenanceViewComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports